import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface DealerState {
  dealerId: string;
  isSurchargeEnabled: boolean;
}

const initialState: DealerState = {
  dealerId: "",
  isSurchargeEnabled: false
};

const dealerSlice = createSlice({
  name: "dealer",
  initialState,
  reducers: {
    setDealerId: (state, action: PayloadAction<string>) => {
      state.dealerId = action.payload;
    },
    setSurchargeValue: (state, action: PayloadAction<boolean>) => {
      state.isSurchargeEnabled = action.payload;
    },
  },
});

export const { setDealerId, setSurchargeValue } = dealerSlice.actions;

export default dealerSlice.reducer;
